import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UserColorService {
    private userColors: Map<string, string> = new Map<string, string>();

    constructor() {
    }

    getUserColor(userEmail: string): string {
        if (!this.userColors.has(userEmail)) {
            const color = this.generateColor(userEmail);
            this.userColors.set(userEmail, color);
        }
        return this.userColors.get(userEmail)!;
    }

    private generateColor(userEmail: string): string {
        let hash: number = 0;
        for (let i: number = 0; i < userEmail?.length; i++) {
            hash = userEmail.charCodeAt(i) + ((hash << 5) - hash);
        }
        // 30% lightness to ensure it's dark
        return `hsl(${hash % 360}, 70%, 30%)`;
    }
}
